import React, { useEffect, useState } from 'react';
import Modal, { useModal } from '../Modal';
import { useCustomers } from '../../Data/Customers';
import Search, { SearchBar, useSearch } from '../Search';
import Title from '../Formatting/Customer/Title';
import Subtitle from '../Formatting/Customer/Subtitle';
import Button from '../Button/Button';
import Loading from '../Loading';
import { classNames } from '../../Services/helpers';
import Icon from '../Icons/Icon';
import ButtonRow from '../Button/ButtonRow';

const CustomerPicker = ({title = 'Pick Customer', prompt, isOpen, setIsOpen, onPicked}) => {
    
    return <Modal title={title} isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        {isOpen && <Search data={{search: prompt}}>
            <Inner {...{prompt, onPicked}} />
        </Search>}
    </Modal>
}

const Inner = ({prompt, onPicked}) => {
    const [saving, setSaving] = useState(false);
    const [selected, setSelected] = useState(null);
    const {searchDebounced, setSearchData} = useSearch();
    const {customers, isLoading} = useCustomers(searchDebounced);
    const {closeModal} = useModal();

    useEffect(() => {
        setSearchData({search: prompt})
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [prompt]);

    const handleSelect = () => {
        setSaving(true);
        onPicked(selected).then(() => {
            setSaving(false);
            closeModal();
        }).catch(() => {
            setSaving(false);
        });
    }

    return <>
        <SearchBar isLoading={isLoading} />

        <div className="max-h-[50vh] overflow-y-auto mt-3">
            <ul className="divide-y divide-gray-200">
                {customers && customers.map(customer => {
                    return <Customer key={customer.id} {...{customer, onPicked, selected, setSelected}} />
                })}
                
                {(isLoading || customers === null) && <Loading center className="my-5" />}

                {(isLoading === false && customers?.length === 0) && <>
                    <p className="text-center text-muted text-sm my-8">
                        No customers match your current search
                    </p>
                </>}
            </ul>
        </div>

        <ButtonRow>
            <Button theme="secondary"
                onClick={() => closeModal()}
                label="Cancel"
            />
            <Button theme="primary"
                onClick={handleSelect}
                disabled={selected === null}
                label="Select"
                loading={saving}
            />
        </ButtonRow>
    </>
}

const Customer = ({customer, selected, setSelected}) => {
    const isSelected = selected === customer.id;

    return <li>
        <div className={classNames(
                'p-4 flex flex-row gap-4 rounded-xl',
                isSelected ? 'border-brand border-2 py-3' : 'hover:bg-gray-100 cursor-pointer'
            )}
            onClick={() => setSelected(customer.id)}
        >
            <div>
                <Icon icon={isSelected ? 'CircleCheck' : 'Circle'}
                    className={isSelected ? 'fill-brand' : 'fill-secondary'}
                    center
                />
            </div>
            <div>
                <Title className="font-bold" customer={customer} /><br />
                <Subtitle customer={customer} />
            </div>
        </div>
    </li>
}

export default CustomerPicker;